import { Autocomplete } from '@mui/material';
import { Loading, TextField } from '@shape-ds/components';
import { useIsFetching } from '@tanstack/react-query';
import { buildOwnersOptions } from 'pages/Asset/tabs/Cases/hooks/useFilterCaseOptions';
import { useGetCasesOwnersQuery } from 'queries/cases/queries';
import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import './style.scss';

export function CaseOwner({ isFormDisabled }: { isFormDisabled: boolean }) {
  const { t } = useTranslation();
  const { data, isLoading } = useGetCasesOwnersQuery();
  const isFecthing =
    useIsFetching({ predicate: (query) => query.queryKey.includes('GET_CASE') }) > 0;

  const ownersOptions = useMemo(() => buildOwnersOptions(data?.owners ?? []), [data]);

  const {
    control,
    formState: { errors },
  } = useFormContext();
  return (
    <div className="user-select">
      {isLoading || isFecthing ? (
        <Loading center />
      ) : (
        <Controller
          name="owner_mail"
          control={control}
          rules={{
            required: t('components:authorized_users.modal.required_field'),
          }}
          render={({ field: { value, onChange } }) => {
            const selectedOption = ownersOptions.find(
              (option) => option.value.toLowerCase() === value?.toLowerCase(),
            );

            return (
              <Autocomplete
                popupIcon={<KeyboardArrowDownRoundedIcon />}
                value={selectedOption}
                onChange={(_, selectedOptions) => {
                  if (selectedOptions) {
                    onChange(selectedOptions.value);
                  }
                }}
                disabled={isFormDisabled}
                options={ownersOptions}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => {
                  const fixInputProps = {
                    ...params,
                    inputProps: {
                      ...params.inputProps,
                      value,
                    },
                  };
                  return (
                    <TextField
                      {...fixInputProps}
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: <span>{t('case:Cases.caseOwner')}</span>,
                      }}
                      className="case-owner-mail"
                      placeholder={t('case:placeholders.selectUser')}
                      data-testid="select-owner-mail"
                      error={!!errors.owner_mail}
                      helperText={errors?.owner_mail?.message?.toString()}
                    />
                  );
                }}
              />
            );
          }}
        />
      )}
    </div>
  );
}
